import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

const UrlListarCreditos = ApiUrl + "creditos-extra?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlInsertarCredito = ApiUrl + "creditos-extra?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlActualizarCredito = ApiUrl + "creditos-extra";
const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"

let listaauxiliar = [];
const itemsPerPage = 4;

const estados = ["Activo", "Inactivo"];

export default class GestionCreditosExtra extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagina: 0,
            creditos: [],
            listaCreditos: [],
            modalCreditos: false,
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            id: 0,
            codigo_credextra: "",
            descripcion: "",
            creditos_valor: "",
            hora_docencia: "",
            hora_practica: "",
            hora_autonoma: "",
            hora_totales: "",
            estado_credextra: "Activo"
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
    }

    handleChangeListarCreditos = async () => {
        axios.get(UrlListarCreditos).then(respuesta => {
            const creditos = respuesta.data;
            this.setState({ creditos, listaCreditos: creditos });
            listaauxiliar = creditos;
            const endOffset = this.state.itemOffset + itemsPerPage;
            this.setState({
                currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset),
                pageCount: Math.ceil(listaauxiliar.length / itemsPerPage)
            });
        });
    }

    componentDidMount() {
        this.handleChangeListarCreditos();
    }

    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        const endOffset = newOffset + itemsPerPage;
        this.setState({
            itemOffset: newOffset,
            currentItems: listaauxiliar.slice(newOffset, endOffset)
        });
    }

    mostrarModalIngresar = () => {
        this.setState({
            id: 0,
            codigo_credextra: "",
            descripcion: "",
            creditos_valor: "",
            hora_docencia: "",
            hora_practica: "",
            hora_autonoma: "",
            hora_totales: "",
            estado_credextra: "Activo",
            modalCreditos: true
        });
    }

    mostrarModalModificar = (registro) => {
        this.setState({
            id: registro.id,
            codigo_credextra: registro.codigo_credextra,
            descripcion: registro.descripcion,
            creditos_valor: registro.creditos,
            hora_docencia: registro.hora_docencia,
            hora_practica: registro.hora_practica,
            hora_autonoma: registro.hora_autonoma,
            hora_totales: registro.hora_totales,
            estado_credextra: registro.estado_credextra ? "Activo" : "Inactivo",
            modalCreditos: true
        });
    }

    ocultarModalIngresar = () => {
        this.setState({ modalCreditos: false });
    }

    registrarCredito = () => {
        const {
            id, codigo_credextra, descripcion, creditos_valor,
            hora_docencia, hora_practica, hora_autonoma, hora_totales, estado_credextra
        } = this.state;

        const datos = {
            id,
            codigo_credextra,
            descripcion,
            creditos: creditos_valor,
            hora_docencia,
            hora_practica,
            hora_autonoma,
            hora_totales,
            estado_credextra: estado_credextra === "Activo"
        };

        const url = id === 0 ? UrlInsertarCredito : `${UrlActualizarCredito}/${id}${api_key}`;
        const metodo = id === 0 ? "post" : "put";

        axios[metodo](url, datos).then(response => {
            if (response.data.success) {
                swal("Operación Exitosa!", { icon: "success" });
                this.handleChangeListarCreditos();
                this.ocultarModalIngresar();
            }
        }).catch(() => {
            swal("Error en la operación", { icon: "error" });
        });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <b>Gestión de Créditos Extra</b>
                    </div>
                    <div className="p-3 rounded-3 mt-3">
                        <h6 className="fw-bold text-center mb-3 text-azul">Listado de Créditos Extra</h6>
                        <div className="table-responsive">
                            <table className="table table-hover table-sm-custom">
                                <thead>
                                    <tr className='text-azul'>
                                        <th>ID</th>
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th>Créditos</th>
                                        <th>Horas Totales</th>
                                        <th>Estado</th>
                                        <th>Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems && this.state.currentItems.map((cred) => (
                                        <tr key={cred.id} className='text-azul'>
                                            <td>{cred.id}</td>
                                            <td>{cred.codigo_credextra}</td>
                                            <td>{cred.descripcion}</td>
                                            <td>{cred.creditos}</td>
                                            <td>{cred.hora_totales}</td>
                                            <td className={cred.estado_credextra ? "table-success" : "table-danger"}>
                                                {cred.estado_credextra ? "Activo" : "Inactivo"}
                                            </td>
                                            <td>
                                                <button className="btn" onClick={() => this.mostrarModalModificar(cred)}>
                                                    <i className="fa fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-center mt-4 ">
                                <ReactPaginate
                                    previousLabel="<"
                                    nextLabel=">"
                                    pageCount={this.state.pageCount}
                                    onPageChange={this.handlePageClick}
                                    containerClassName="pagination pagination-sm-custom"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    activeClassName="active"
                                />
                            </div>
                            <Modal isOpen={this.state.modalCreditos}>
                                <ModalHeader>Registro de Crédito Extra</ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <label>Código:</label>
                                        <input type="text" name="codigo_credextra" value={this.state.codigo_credextra} onChange={this.handleChange} className="form-control" />
                                        <label>Descripción:</label>
                                        <textarea name="descripcion" value={this.state.descripcion} onChange={this.handleChange} className="form-control" rows="2" />
                                        <label>Créditos:</label>
                                        <input type="number" name="creditos_valor" value={this.state.creditos_valor} onChange={this.handleChange} className="form-control" />
                                        <label>Horas Docencia:</label>
                                        <input type="number" name="hora_docencia" value={this.state.hora_docencia} onChange={this.handleChange} className="form-control" />
                                        <label>Horas Práctica:</label>
                                        <input type="number" name="hora_practica" value={this.state.hora_practica} onChange={this.handleChange} className="form-control" />
                                        <label>Horas Autónomas:</label>
                                        <input type="number" name="hora_autonoma" value={this.state.hora_autonoma} onChange={this.handleChange} className="form-control" />
                                        <label>Horas Totales:</label>
                                        <input type="number" name="hora_totales" value={this.state.hora_totales} onChange={this.handleChange} className="form-control" />
                                        <label>Estado:</label>
                                        <select name="estado_credextra" value={this.state.estado_credextra} onChange={this.handleChange} className="form-control">
                                            {estados.map(est => <option key={est} value={est}>{est}</option>)}
                                        </select>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <button className="btn btn-success" onClick={this.registrarCredito}>Guardar</button>
                                    <button className="btn btn-danger" onClick={this.ocultarModalIngresar}>Cancelar</button>
                                </ModalFooter>
                            </Modal>
                        </div>
                        <button className="btn btn-primary" onClick={this.mostrarModalIngresar}>Agregar Crédito Extra</button>
                    </div>
                </div>
            </div>
        );
    }
}